import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errMsg, HAZARD_FIELDS } from "@/lib/hsUtil";

const LONG = new Set(["controls", "potential_harm", "hazard"]);

const FormField = ({ k, label, value, onChange }) => (
  <label className={`block ${LONG.has(k) ? "md:col-span-2" : ""}`}>
    <span className="text-xs text-silver">{label}{k === "hazard" ? " *" : ""}</span>
    {LONG.has(k)
      ? <textarea className="input w-full" rows={k === "controls" ? 4 : 2} value={value} onChange={e => onChange(k, e.target.value)} data-testid={`hz-form-${k}`}/>
      : <input className="input w-full" value={value} onChange={e => onChange(k, e.target.value)} data-testid={`hz-form-${k}`}/>}
  </label>
);

export default function HazardForm({ hazard, onClose, onSaved }) {
  const [h, setH] = useState(() => Object.fromEntries(HAZARD_FIELDS.map(([k]) => [k, hazard?.[k] || ""])));
  const [busy, setBusy] = useState(false);
  const change = (k, v) => setH(x => ({ ...x, [k]: v }));
  async function save() {
    if (!h.hazard.trim()) { toast.error("Hazard is required"); return; }
    setBusy(true);
    try {
      if (hazard?.id) await api.put(`/hs/hazard-library/${hazard.id}`, h);
      else await api.post("/hs/hazard-library", h);
      toast.success(hazard?.id ? "Hazard updated" : "Hazard added");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  }
  return (
    <div className="fixed inset-0 bg-black/80 z-40 flex items-center justify-center p-4" data-testid="hz-form-modal">
      <div className="card max-w-3xl w-full max-h-[90vh] overflow-y-auto space-y-3">
        <div className="flex items-center justify-between">
          <h3 className="text-silver">{hazard?.id ? "Edit hazard" : "Add hazard"}</h3>
          <button className="opacity-70" onClick={onClose} data-testid="hz-form-close">×</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {HAZARD_FIELDS.map(([k, label]) => <FormField key={k} k={k} label={label} value={h[k]} onChange={change}/>)}
        </div>
        <div className="flex gap-2">
          <button className="btn-silver" disabled={busy} onClick={save} data-testid="hz-form-save">{busy ? "Saving…" : "Save hazard"}</button>
          <button className="btn-ghost" onClick={onClose} data-testid="hz-form-cancel">Cancel</button>
        </div>
      </div>
    </div>
  );
}
